export const SET_FILTER = 'manageStores/SET_FILTER';
export const STORE_LIST_REQUESTING = 'manageStores/STORE_LIST_REQUESTING';
export const STORE_LIST_SUCCESS = 'manageStores/STORE_LIST_SUCCESS';
export const STORE_LIST_ERROR = 'manageStores/STORE_LIST_ERROR';

export const STORE_DETAIL_REQUESTING = 'manageStores/STORE_DETAIL_REQUESTING';
export const STORE_DETAIL_SUCCESS = 'manageStores/STORE_DETAIL_SUCCESS';
export const STORE_DETAIL_ERROR = 'manageStores/STORE_DETAIL_ERROR';

export const UPDATE_STORE_REQUESTING = 'manageStores/UPDATE_STORE_REQUESTING';
export const UPDATE_STORE_SUCCESS = 'manageStores/UPDATE_STORE_SUCCESS';
export const UPDATE_STORE_ERROR = 'manageStores/UPDATE_STORE_ERROR';

export const ADD_IMAGE_REQUESTING = 'manageStores/ADD_IMAGE_REQUESTING';
export const ADD_IMAGE_SUCCESS = 'manageStores/ADD_IMAGE_SUCCESS';

export const DELETE_IMAGE_REQUESTING = 'manageStores/DELETE_IMAGE_REQUESTING';
export const DELETE_IMAGE_SUCCESS = 'manageStores/DELETE_IMAGE_SUCCESS';

export const OTP_REQUESTING = 'manageStores/OTP_REQUESTING';
export const OTP_REQUESTING_SUCCESS = 'manageStores/OTP_REQUESTING_SUCCESS';
export const OTP_REQUESTING_ERROR = 'manageStores/OTP_REQUESTING_ERROR';

export const VERIFY_OTP_REQUESTING = 'manageStores/VERIFY_OTP_REQUESTING';
export const VERIFY_OTP_SUCCESS = 'manageStores/VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_ERROR = 'manageStores/VERIFY_OTP_ERROR';

export const CATEGORY_LIST_REQUESTING = 'manageStores/CATEGORY_LIST_REQUESTING';
export const CATEGORY_LIST_SUCCESS = 'manageStores/CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_ERROR = 'manageStores/CATEGORY_LIST_ERROR';

export const CATEGORY_UPDATE_REQUESTING =
	'manageStores/CATEGORY_UPDATE_REQUESTING';
export const CATEGORY_UPDATE_SUCCESS = 'manageStores/CATEGORY_UPDATE_SUCCESS';
export const CATEGORY_UPDATE_ERROR = 'manageStores/CATEGORY_UPDATE_ERROR';

export const IMAGE_UPDATE_LOADER_TRUE = 'manageStores/IMAGE_UPDATE_LOADER_TRUE';
export const IMAGE_UPDATE_LOADER_FALSE =
	'manageStores/IMAGE_UPDATE_LOADER_FALSE';

export const TOTAL_STORE_LIST_REQUESTING =
	'manageStores/TOTAL_STORE_LIST_REQUESTING';
export const SEARCH_MORE_STORE_SUCCESS =
	'manageStores/SEARCH_MORE_STORE_SUCCESS';

export const RESET_MANAGE_STORES = 'manageStores/RESET';
